import { Dashboard } from './model'
import * as actions from './actions'
import { DashboardActions } from './actions'

const initialState: Dashboard =  <Dashboard> {
  'id': -1,
  'title': '',
  'uri': '',
  'type': 'db',
  'tags': [],
  'isStarred': false,
  'autoRefresh': false
};

const reducer = (state: Dashboard = initialState, action: DashboardActions): Dashboard => {
  switch (action.type) {
    case actions.ChangeStarredDashboard:
      return {
        ...state,
        isStarred: action.payload.starred
      };
    default:
      return state
  }
};

export default reducer
